"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.poll = poll;
async function poll(functionToCall, evaluationFunction, retryIntervalMs = 100, timeoutInMs = 250) {
    let result;
    const throwTimeout = new Promise((resolve) => {
        setTimeout(() => {
            resolve(result);
        }, timeoutInMs);
    });
    const getResult = new Promise(async (resolve) => {
        result = await functionToCall();
        while (!evaluationFunction(result)) {
            result = await new Promise((resolveRetry) => {
                setTimeout(() => {
                    resolveRetry(functionToCall());
                }, retryIntervalMs);
            });
        }
        return resolve(result);
    });
    return Promise.race([throwTimeout, getResult]);
}
//# sourceMappingURL=PollingWrapper.js.map